import { useState } from "react";
import { capturePrivateSession, assertPrivateSessionLifetime } from "@/lib/api/private-session";
import { dispatchCommand, prepareCommand, sendCommand } from "@/shared/invoices/invoiceCommands";
/** Callbacks retained by dialogs/print jobs cannot mint a command for a newer store. */
export function useInvoiceCommands() {
  const [bound] = useState(bindCommands);
  return bound;
}
function bindCommands() {
  const lifetime = capturePrivateSession();
  return {
    dispatchCommand: (...args: Parameters<typeof dispatchCommand>) => { assertPrivateSessionLifetime(lifetime); return dispatchCommand(...args); },
    prepareCommand: (...args: Parameters<typeof prepareCommand>) => { assertPrivateSessionLifetime(lifetime); return prepareCommand(...args); },
    sendCommand: (...args: Parameters<typeof sendCommand>) => { assertPrivateSessionLifetime(lifetime); return sendCommand(...args); },
  };
}
